import React from "react";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import formatPhoneNumber from "../../../../../helpers/formatephoneNumber";
export const DisasterListingCard = ({
  dataList,
  moduleData,
  step,
  loading,
  width,
}) => {
  const allowedKeys = [
    "Attorney",
    "Financial Advisor",
    "Insurance Agent",
    "Accountant/CPA",
    "Care Manager",
    "Social Worker",
  ];
  const history = useHistory();
  const dispatch = useDispatch();
  console.log("home and saf", dataList);
  return (
    <div
      className="DisabilityCardMain"
      style={{ position: "relative", width: width ? width : "" }}
    >
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon && (
            <img
              width={66}
              height={56}
              src={moduleData.Icon}
              alt={moduleData.name}
            ></img>
          )}

          {/* {moduleData.name} */}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Home safety & Security", "Recovery plan", "Important document storage", "Emergency contacts information", "Evacuation Planning", "Emergency Supplies Inventory", "Property Documentation"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}          
        </div>              
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/disaster");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      <div className="disaaster-DashboardListing" style={{ maxHeight: "7rem" }}>
        {moduleData.name === "Primary Caregivers" ? (
          dataList && dataList.length > 0 ? (
            dataList.map((item, index) => (
              <div key={index} className="disaaster-DashboardListingRow">
                <div className="checkListName">
                  {item.Name ? item.Name : "N/A"}
                </div>
                <div className="row-Status">
                  {item.Relationship ? item.Relationship : "N/A"}
                </div>
              </div>
            ))
          ) : (
            <div className="disaaster-DashboardListingNoData">
              No data to show
            </div>
          )
        ) : moduleData.name === "Evacuation Planning" ? (
          dataList && dataList.length > 0 ? (
            dataList.map((item, index) => (
              <div key={index} className="disaaster-DashboardListingRow">
                <div className="checkListName">Primary Evacuation Route</div>
                <div className="row-Status">
                  {item["Primary Evacuation Route"] || "N/A"}
                </div>
              </div>
            ))
          ) : (
            <div className="disaaster-DashboardListingNoData">
              No data to show
            </div>
          )
        ) : (
          <React.Fragment>
            {dataList && dataList.length > 0 ? (
              dataList.map((item) => {
                const entries = Object.entries(item).filter(
                  ([key]) =>
                    !key.endsWith("_createdAt") &&
                    !key.endsWith("_updatedAt") &&
                    key !== "Specialty"
                );

                // Take the last two entries after filtering
                const lastTwoEntries = entries.slice(-2);

                return (
                  lastTwoEntries &&
                  lastTwoEntries.map(([key, value], index) => {
                    let displayValue = "N/A";

                    const isDate = moment(
                      value,
                      moment.ISO_8601,
                      true
                    ).isValid();
                    const isNumeric =
                    !isNaN(value) && value !== "" && value !== null && value !== false;
        
                    if (isDate) {
                      displayValue = moment(value).format("MM/DD/YYYY");
                    }else if (key === "Phone Number" && value) {
                      displayValue = formatPhoneNumber(value);
                    } else if (
                      isNumeric &&
                      (key.toLowerCase().includes("amount") || key.toLowerCase().includes("value"))
                    ) {
                      displayValue = new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(value);
                    } else if (isNumeric) {
                      displayValue = "$" + Number(value).toLocaleString("en-US", { minimumFractionDigits: 2 });
                    } else if (value) {
                      displayValue = value;
                    }

                    return (
                      <div
                        key={index}
                        className="disaaster-DashboardListingRow"
                      >
                        <div className="checkListName">{key}</div>
                        <div className="row-Status">{displayValue}</div>
                      </div>
                    );
                  })
                );
              })
            ) : (
              <div className="disaaster-DashboardListingNoData">
                No data to show
              </div>
            )}
          </React.Fragment>
        )}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
